<ng-container *ngIf="((priceObject && priceObject.applicationStatus === 'COMPLETED' &&
                        (priceObject.role === 'NOTARY' || priceObject.role === 'PAYER')) ||
                      (priceObject && fg && (priceObject.applicationStatus === 'SUBMITTED' ||
                                              priceObject.applicationStatus === 'MANUALLY_SUBMITTED' ))
                      )"
        >
        <div
            [formGroup]="fg"
            class="price-card mt-3"
            [ngClass]="{ collapsed: priceTableToggler }"
            style="box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);"
        >
          <div class="card-panel">
            <div class="card-body"  style="background-color: rgb(245, 245, 245);">
                  <div  class="row justify-content-between buyer-form">
                    <div class="col-lg-5 col-md-6 mb-6">
                      <img height="60px" width="80px" class="magnifying-glass-title__icon"
                           src="assets/images/icon-creditCard.png" alt="papyrus icon for table title">
                      <h3 class="d-inline-block align-self-center ml-lg-3 section-title" style="font-size: 1.4rem; padding-top: 10px;">
                        {{ priceObject.title }} <span>{{ priceObject.total | currency:'EUR':'symbol':'1.2-2':'es-ES'}}</span>
                      </h3>
                    </div>

                    <div *ngIf="priceObject.applicationStatus !== 'COMPLETED'" class="row justify-content-between mt-3">
                      <div class="row col-lg-8 col-md-6 col-sm-12">
                        <div class="col-lg-6 col-md-6">
                          <h5 class="card-subtitle mb-2 text-muted" style="font-size: 1rem; padding-left: 5px;">
                            <ng-container *ngIf="priceObject.applicationStatus !== 'COMPLETED'">
                              <input type="hidden" value="{{priceObject.cadID}}" class="buyerCatId">
                              <mat-form-field appearance="fill">
                                <mat-label *ngIf="priceObject.applicationStatus !== 'COMPLETED'">
                                  <span class="bold">  {{ priceObject.label }}</span>
                                </mat-label>
                                <mat-label *ngIf="priceObject.applicationStatus == 'COMPLETED'">
                                  <span class="bold">  {{ priceObject.cadID }}</span>
                                </mat-label>
                                <mat-select formControlName="buyerTaxId" disableOptionCentering="true" panelClass="mt-3">
                                  <mat-option *ngFor="let buyer of priceObject.buyers" [value]="buyer.taxCode">
                                    {{ buyer.surname }} {{ buyer.firstName }}
                                  </mat-option>
                                </mat-select>
                                <mat-error>
                                  Παρακαλώ επιλέξτε έναν αποκτών
                                </mat-error>
                              </mat-form-field>
                            </ng-container>
                          </h5>
                        </div>
                        <div class="col-lg-6 col-md-8">
                          <h5 class="card-subtitle mb-2 " style="font-size: 1rem; padding-left: 5px;">
                            <ng-container *ngIf="priceObject.applicationStatus == 'COMPLETED'">
                              <span class="bold">  {{ priceObject.paymentMethod }}</span>
                            </ng-container>
                            <ng-container *ngIf="priceObject.applicationStatus !== 'COMPLETED'">
                              <mat-form-field appearance="fill">
                                <mat-label *ngIf="priceObject.applicationStatus !== 'COMPLETED'">
                                  {{ priceObject.labelPaymentMethod }}
                                </mat-label>
                                <mat-label *ngIf="priceObject.applicationStatus == 'COMPLETED'">
                                  <span class="bold">  {{ priceObject.paymentMethod }}</span>
                                </mat-label>
                                <mat-select formControlName="paymentMethod" disableOptionCentering="true" panelClass="mt-3" class="paymnetMethodSelect">
                                  <mat-option *ngFor="let paymnetMethod of priceObject.paymentMethods" value="{{paymnetMethod.id}}">
                                    {{ paymnetMethod.name }}
                                  </mat-option>
                                </mat-select>
                                <mat-error>
                                  Παρακαλώ επιλέξτε μέθοδο πληρωμής
                                </mat-error>
                              </mat-form-field>
                            </ng-container>
                          </h5>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-12">
                        <span class="">
                          Για την επίτευξη μεταγραφής σε 1 εργάσιμη ημέρα απαιτείται η εξόφληση με <b> Κάρτα </b>.
                        </span>
                      </div>
                    </div>

                    <button class="btn btn-secondary app-button mt-2"
                            [ngClass]="priceObject.applicationStatus !== 'COMPLETED' ? 'col-lg-12 col-md-12': 'col-lg-4 col-md-6'"
                            (click)="toggleCard()">
                      <div
                        *ngIf="priceTableToggler; then ArrowDown; else ArrowUp"
                      ></div>
                      <ng-template #ArrowDown>
                        <span class="align-middle">{{ priceObject.buttonCollapse }}</span>
                        <i class="material-icons align-middle">keyboard_arrow_down</i>
                      </ng-template>
                      <ng-template #ArrowUp>
                        <span class="align-middle">{{ priceObject.buttonExpand }}</span>
                        <i class="material-icons align-middle">keyboard_arrow_up</i>
                      </ng-template>
                    </button>
                  </div>



                <div class="price-card-list">
                    <div class="row price-card-list-row"*ngFor="let  item of priceObject.items" style="padding-top: 20px;">
                        <div class="col-9 col-xs-12">
                          <h5 class="card-subtitle text-muted" style="font-size: 0.85rem;">
                            {{item.name}}
                          </h5>
                        </div>
                        <div class="col-3 col-xs-12">
                          <h5 class="card-subtitle text-muted" style="font-size: 0.85rem;">
                            <span class="text-right price-sign">
                              {{ item.price | currency:'EUR':'symbol':'1.2-2':'es-ES' }}
                            </span>
                          </h5>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
</ng-container>
